import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import t from "./CenteredContentLayout.module.js";
import { c as n } from "react/compiler-runtime";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { H1 as a } from "@jetbrains/ring-ui-built/components/heading/heading.js";
//#region src/components/CenteredContentLayout/CenteredContentLayout.tsx
var o = (o) => {
	let s = n(10), { "data-test": c, content: l, children: u, title: d } = o, f = u === void 0 ? l : u, p;
	s[0] === d ? p = s[1] : (p = !!d && /* @__PURE__ */ r(a, {
		className: t.title,
		children: d
	}), s[0] = d, s[1] = p);
	let m;
	s[2] === f ? m = s[3] : (m = /* @__PURE__ */ r(e, {
		as: "div",
		children: f
	}), s[2] = f, s[3] = m);
	let h;
	s[4] !== p || s[5] !== m ? (h = /* @__PURE__ */ i("div", { children: [p, m] }), s[4] = p, s[5] = m, s[6] = h) : h = s[6];
	let g;
	return s[7] !== c || s[8] !== h ? (g = /* @__PURE__ */ r("div", {
		"data-test": c,
		className: t.container,
		children: h
	}), s[7] = c, s[8] = h, s[9] = g) : g = s[9], g;
};
//#endregion
export { o as CenteredContentLayout };
